import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  setPileheadSource,
  setNumberOfPileheads,
  selectPileheadSource,
  selectNumberOfPileheads,
} from "../../../../store/slices/lvTextSlice";
import { selectWerkstoffUebergangsrohr } from "../../../../store/slices/pileHeadConstructionSlice";
import Headline from "../../../../components/UI/Headline";
import PileheadSource from "./PileheadSource";
import NumberOfPileheads from "./NumberOfPileheads";
import TransitionTubeMaterial from "./TransitionTubeMaterial";

export default function PositionPileheads() {
  const { t } = useTranslation("translation");

  const pileheadSource = useSelector(selectPileheadSource);
  const numberOfPileheads = useSelector(selectNumberOfPileheads);
  const transitionTubeMaterial = useSelector(selectWerkstoffUebergangsrohr, Object.is);
  const transitionTubeMaterialHumanReadable =
    transitionTubeMaterial === 0
      ? t("aeussre.plasticTube")
      : transitionTubeMaterial === 1
        ? t("aeussre.steelTube")
        : "";

  const dispatch = useDispatch();
  const dispatchSetPileheadSource = (value) => dispatch(setPileheadSource(value));
  const dispatchSetNumberOfPileheads = (value) => dispatch(setNumberOfPileheads(value));

  return (
    <div className="mt-5">
      <Headline text={t("lvText.positionPileheads.headline")} />
      <PileheadSource value={pileheadSource} set={dispatchSetPileheadSource} />
      <NumberOfPileheads value={numberOfPileheads} set={dispatchSetNumberOfPileheads} />
      {pileheadSource === t("lvText.positionPileheads.pileheadSourceSmarttitan") && (
        <TransitionTubeMaterial value={transitionTubeMaterialHumanReadable} />
      )}
    </div>
  );
}
